import React, { useState, useEffect } from "react";
import { Autocomplete, Box, Button, CircularProgress, InputLabel, TextField, Typography, useTheme, MenuItem, Select } from "@mui/material";
import SubHeader from "../../../../../components/SubHeader";
import DeductionList from "./DeductionList";
import styles from "./style";
// import { useNavigate } from "react-router-dom";
import Modal from "../../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Download } from "@mui/icons-material";

const DeductionPage = ({ data, getDeductionType,handleDownload, deductionType, handleUpdate, open, setOpen, total, page, setPage, handleDelete, handleFilter, handleRequest, loading, employeeData, handleEmployee, handleAdd, getDeductionList }) => {
  const theme = useTheme();
  const handleEmployees = (value) => {
    handleEmployee(value);
  }

  const [change, setChange] = useState(false);
  const [item, setItem] = useState();
  const [from, setFrom] = useState("");
  const [optionValue, setOptionValue] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [type, setType] = useState("");
  const [typeD, setTypeD] = useState("");
  const [salary, setSalary] = useState("");
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Manual");
  const permissionObj = JSON.parse(localStorage.getItem("permission"))
  const permission = permissionObj?.deduction?.isEdit
  const role = localStorage.getItem("role")
  const isEmployeeRole = role === "Employee" || role === "employee";
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());

  const resetForm = () => {
    setType("");
    setTypeD("");
    setSalary("");
    setAmount("");
    setDesc("");
    setEmployeeId("");
    setOptionValue("");
    setPaymentMethod("Manual");
    setToDate(dayjs()); // Reset to current date
    setFromDate(dayjs()); // Reset to current date
  };

  useEffect(() => {
    if (from === "edit" && item) {
      setOptionValue(item?.employeeDetails?.personalInfo.email || "");
      setAmount(item?.deductions?.[0]?.rateValue || "");
      setSalary(item?.deductions?.[0]?.deductType || "");
      setType(item?.deductions?.[0]?.type || "");
      setTypeD(item?.deductions?.[0]?.payType || "");
      setEmployeeId(item?.employeeDetails?._id || "");
      setDesc(item?.deductions?.[0]?.desc || "");
      setPaymentMethod(item?.deductions?.[0]?.paymentMethod || "Manual");

      setFromDate(item?.deductions?.[0]?.start ? dayjs(item.deductions[0].start) : dayjs());
      setToDate(item?.deductions?.[0]?.end ? dayjs(item.deductions[0].end) : dayjs());

      setChange(false);
    } else if (from === "create") {
      resetForm();
    }
  }, [item, from]);

  const handleData = () => {
    if (from === "edit") {
      handleUpdate(item?._id, employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod)
    } else {
      handleAdd(employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod)
      resetForm();
    }
  }
  const isFormInvalid = !employeeId || !typeD || !type || !amount || toDate.isBefore(fromDate, "day");


  return (
    <>
      {/* {loader && <CircularIndeterminate/>} */}
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={styles.heading}>{isEmployeeRole ? "My Deduction" : "Deduction"}</Typography>
         
        <Box display="flex">
        <Button
            sx={styles.exportBtn}
            onClick={handleDownload}
          >
            <Download />
            Export Pdf
          </Button>
        
        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          {(role === "Admin" || role === "SuperAdmin" || permission?.deduction?.isEdit) ? <Button variant="contained" color="success" sx={styles.checkoutBtn} onClick={() => { resetForm(), setItem(null), setOpen(true), setFrom("create"), getDeductionType() }}
          > + Add Deduction
          </Button> : null}
        </Box>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title={isEmployeeRole ? "My Deduction List" : "Deduction List"}
          search={true}
          // sortBy={true}
          onchange={(e) => handleFilter(e)}
          filter={handleFilter}
          isShowFilter={false}
          onCompanyChange={getDeductionList}
          handleSort={(e) => handleFilter("", e)} />
        <DeductionList permission={permission} role={role} getDeductionType={getDeductionType} page={page} total={total} setPage={setPage} data={data} handleDelete={handleDelete} setItem={setItem} setFrom={setFrom} setOpen={setOpen} setChange={setChange} />
      </Box>
      < Modal open={open} setOpen={setOpen} disabled={isFormInvalid} btnText={from === "edit" ? "Save Changes" : "Add New"} handleCheck={() => handleData()} title={from === "edit" ? "Edit Deductions" : "Create Deductions"}
        handleRequest={handleRequest}>
        {from === "edit" ?
          <Box>
            <InputLabel sx={styles.label}>Employee Email</InputLabel>
            <TextField
              // label={"Reason"}
              value={item?.employeeDetails?.personalInfo?.email}
              onChange={(e) => { setOptionValue(e.target.value); setChange(true); }}
              rows={2}
              sx={styles.reason}
              placeholder="Enter Employee Email"

            />
          </Box>
          :
          <Box>
            <Autocomplete
              id="autocomplete"
              options={employeeData || []}
              getOptionLabel={(option) => option?.personalInfo?.email}
              onInputChange={(event, newInputValue) => {
                handleEmployees(newInputValue);
              }}
              onChange={(event, newValue) => {
                setOptionValue(newValue);
                setEmployeeId(newValue?._id)
              }}
              value={optionValue || null}
              renderInput={(params) => (
                <><InputLabel sx={styles.label}>{"Employee Email"}</InputLabel>
                  <TextField
                    {...params}
                    sx={{ ...styles.modalInput, ...styles.inputSpace }}
                    variant="outlined"
                    value={change ? optionValue : item?.employeeDetails?.personalInfo.email || ""}
                    placeholder="Enter Employee Email"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }} /></>
              )}
            />
          </Box>
        }
        <Box sx={styles.projectContainer}>
          <Box sx={{ display: "flex", mb: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]} sx={styles.calender}>
                <Box>
                  <InputLabel sx={styles.label}>From</InputLabel>
                  <DatePicker value={fromDate} onChange={(newValue) => { setFromDate(newValue) }} sx={styles.calenderInput} slotProps={{
                    field: {
                      readOnly: true
                    }
                  }}
                  />
                </Box>
                <Box>
                  <InputLabel sx={styles.label}>To</InputLabel>
                  <DatePicker
                    minDate={fromDate}
                    value={toDate}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                    sx={styles.calenderInput}
                    onChange={(newValue) => { setToDate(newValue); }}
                  />
                </Box>
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", mb: 2 }}>
            <Box sx={{ ...styles.inputGrid, width: "50%" }}>
              <InputLabel sx={styles.labels}>Type</InputLabel>
              <Select
                value={change ? type : item?.deductions?.[0]?.type || ""}
                onChange={(e) => { setType(e.target.value); setChange(true); }}
                name="type"
                sx={styles.hoursInput}
                displayEmpty

              >
                <MenuItem disabled value="">
                  Select Type
                </MenuItem>
                {deductionType.map((items, index) => (
                  <MenuItem sx={styles.dropDownMenu} key={index} value={items?.name}>
                    {items?.name}
                  </MenuItem>
                ))}
              </Select>


            </Box>
            <Box sx={{ ...styles.inputGrids, width: "50%" }}>
              <InputLabel sx={styles.labels}>{typeD === "Percentage" ? "Rate" : "Amount"}</InputLabel>
              <TextField
                type="number"
                sx={styles.hoursInput}
                name="amount"
                value={change ? amount : item?.deductions?.[0]?.rateValue || ""}
                onChange={(e) => { setAmount(e.target.value); setChange(true); }}
                autoComplete="amount"
                placeholder="Enter Amount"
              />

            </Box>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ ...styles.inputGrid, width: "50%" }}>
              <Select
                value={change ? typeD : item?.deductions?.[0]?.payType || ""}
                onChange={(e) => { setTypeD(e.target.value); setChange(true); }}
                name="type"
                sx={styles.hoursInput}
                displayEmpty
              >
                <MenuItem disabled value="">
                  Select Type
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="Weekly">
                  Weekly
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="Amount">
                  Amount
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="PerCredit">
                  Per Credit
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="Percentage">
                  Percentage
                </MenuItem>
              </Select>
            </Box>
            <Box sx={{ ...styles.inputGrids, width: "50%" }}>
              <Select
                value={change ? salary : item?.deductions?.[0]?.deductType || ""}
                onChange={(e) => { setSalary(e.target.value); setChange(true); }}
                name="type"
                sx={styles.hoursInput}
                displayEmpty
                disabled={typeD !== "Percentage"}
              >
                <MenuItem disabled value="">
                  Select Type
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="Gross">
                  Gross
                </MenuItem>
                <MenuItem sx={styles.dropDownMenu} value="Salary">
                  Salary
                </MenuItem>
              </Select>
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel sx={styles.labels}>Payment Method</InputLabel>
            <Select
              value={change ? paymentMethod : item?.deductions?.[0]?.paymentMethod || "Manual"}
              onChange={(e) => {
                setPaymentMethod(e.target.value);
                setChange(true);
              }}
              sx={{
                ...styles.hoursInput,
                "& .MuiOutlinedInput-root": {
                  minHeight: "56.5px",
                  height: "56.5px",
                  "& .MuiSelect-select": {
                    py: 1,
                    display: "flex",
                    alignItems: "center"
                  }
                }
              }}
              displayEmpty
            >
              <MenuItem value="Manual">Manual</MenuItem>
              <MenuItem value="Auto">Auto</MenuItem>
            </Select>
          </Box>
          <Box sx={{ mt: 1 }}>
            <InputLabel sx={styles.labels}>Description</InputLabel>
            <TextField
              sx={styles.hoursInput}
              name="desc"
              rows={2}
              multiline={true}
              value={change ? desc : item?.deductions?.[0]?.desc || ""}
              onChange={(e) => { setDesc(e.target.value); setChange(true); }}
              // onFocus={handleFocus}
              autoComplete="amount"
              placeholder="Enter Description"
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeductionPage;
